import { _ as I } from "./OrDateTimePicker.vue_vue_type_script_lang-WqJrqWZ3.mjs";
import { resolveComponent as a, resolveDirective as y, openBlock as d, createElementBlock as H, normalizeClass as u, createBlock as s, withCtx as t, renderSlot as b, createTextVNode as i, toDisplayString as n, createCommentVNode as T, withDirectives as m, withModifiers as U, createVNode as l, createElementVNode as g, vShow as k } from "vue";
import { _ as z } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const E = /* @__PURE__ */ g("div", {
  class: /* @__PURE__ */ u(["grow"])
}, null, -1);
function N(e, o, R, A, j, G) {
  const V = a("OrLabel"), $ = a("OrDateTimePickerDateControl"), S = a("OrDateTimePickerTimeControl"), p = a("OrDateTimePickerMobileControl"), P = a("OrDateTimePickerPopoverHeader"), h = a("OrDateTimePickerMonthSelect"), F = a("OrDateTimePickerDateSelect"), D = a("OrDateTimePickerPopoverFooter"), O = a("OrPopover"), C = a("OrDateTimePickerTimeSelect"), w = a("OrIconButton"), L = a("OrIcon"), B = a("OrInputBox"), q = a("OrHint"), M = a("OrError"), v = y("dropdown-open"), f = y("dropdown-close");
  return d(), H("div", {
    ref: "root",
    class: u(e.rootStyles)
  }, [
    e.$slots.label || e.$slots.addon || e.label ? (d(), s(V, {
      key: 0,
      variant: "input",
      required: e.required,
      disabled: e.disabled
    }, {
      addon: t(() => [
        b(e.$slots, "addon")
      ]),
      default: t(() => [
        b(e.$slots, "label", {}, () => [
          i(n(e.label), 1)
        ])
      ]),
      _: 3
    }, 8, ["required", "disabled"])) : T("", !0),
    m((d(), s(B, {
      ref: "inputBox",
      variant: e.variant,
      size: e.size,
      invalid: !!e.error,
      readonly: e.readonly,
      disabled: e.disabled
    }, {
      addon: t(() => [
        e.modelValue ? (d(), s(w, {
          key: 0,
          icon: "close",
          color: "inherit",
          disabled: e.readonly || e.disabled,
          onClick: o[11] || (o[11] = U((r) => e.$emit("update:modelValue", void 0), ["stop"]))
        }, null, 8, ["disabled"])) : (d(), s(L, {
          key: 1,
          icon: "calendar_month",
          variant: "outlined"
        }))
      ]),
      default: t(() => [
        m(l($, {
          modelValue: e.draft,
          "onUpdate:modelValue": o[0] || (o[0] = (r) => e.draft = r),
          format: e.resolvedDateFormat,
          locale: e.resolvedLocale,
          selected: e.datePopover && e.datePopover.state === "open",
          required: e.required,
          readonly: e.readonly,
          disabled: e.disabled
        }, null, 8, ["modelValue", "format", "locale", "selected", "required", "readonly", "disabled"]), [
          [v, e.toggleDatePopover],
          [f, e.closeDatePopover]
        ]),
        m(l(S, {
          modelValue: e.draft,
          "onUpdate:modelValue": o[1] || (o[1] = (r) => e.draft = r),
          format: e.resolvedTimeFormat,
          locale: e.resolvedLocale,
          selected: e.timePopover && e.timePopover.state === "open",
          required: e.required,
          readonly: e.readonly,
          disabled: e.disabled
        }, null, 8, ["modelValue", "format", "locale", "selected", "required", "readonly", "disabled"]), [
          [v, e.toggleTimePopover],
          [f, e.closeTimePopover]
        ]),
        l(O, {
          ref: "datePopover",
          variant: "auto",
          "bottom-sheet-props": { variant: "basic" },
          trigger: e.anchor || e.inputBoxRoot,
          placement: "bottom-start",
          "fallback-placement": "start",
          onClose: o[6] || (o[6] = (r) => e.reset())
        }, {
          default: t(() => [
            g("div", {
              class: u(e.datePopoverStyles)
            }, [
              l(P, null, {
                default: t(() => [
                  l(p, { label: "Date" }, {
                    default: t(() => [
                      i(n(e.draft ? e.formatMobileDate(e.draft, e.resolvedDateFormat, e.resolvedLocale) : "--"), 1)
                    ]),
                    _: 1
                  }),
                  l(p, { label: "Time" }, {
                    default: t(() => [
                      i(n(e.draft ? e.formatMobileTime(e.draft, e.resolvedTimeFormat, e.resolvedLocale) : "--"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              l(h, {
                modelValue: e.initialValue,
                "onUpdate:modelValue": o[2] || (o[2] = (r) => e.initialValue = r),
                locale: e.resolvedLocale,
                "year-filter": e.yearFilter,
                "month-filter": e.monthFilter,
                "years-options-length": e.yearsOptionsLength
              }, null, 8, ["modelValue", "locale", "year-filter", "month-filter", "years-options-length"]),
              l(F, {
                modelValue: e.draft,
                "onUpdate:modelValue": o[3] || (o[3] = (r) => e.draft = r),
                "initial-value": e.initialValue,
                format: e.resolvedDateFormat,
                "week-starts-on": e.weekStartsOn,
                locale: e.resolvedLocale,
                "date-filter": e.dateFilter,
                "date-highlighter": e.dateHighlighter
              }, null, 8, ["modelValue", "initial-value", "format", "week-starts-on", "locale", "date-filter", "date-highlighter"]),
              l(D, {
                disabled: e.invalid,
                onApply: o[4] || (o[4] = (r) => {
                  e.apply(), e.datePopover && e.datePopover.close();
                }),
                onReset: o[5] || (o[5] = (r) => {
                  e.reset(), e.datePopover && e.datePopover.close();
                })
              }, null, 8, ["disabled"])
            ], 2)
          ]),
          _: 1
        }, 8, ["trigger"]),
        l(O, {
          ref: "timePopover",
          class: u(e.timePopoverStyles),
          "custom-styles": e.timePopoverStyles,
          variant: "auto",
          "bottom-sheet-props": { variant: "basic" },
          trigger: e.anchor || e.inputBoxRoot,
          placement: "bottom-start",
          "fallback-placement": "start",
          onClose: o[10] || (o[10] = (r) => e.reset())
        }, {
          default: t(() => [
            l(P, null, {
              default: t(() => [
                l(p, { label: "Date" }, {
                  default: t(() => [
                    i(n(e.draft ? e.formatMobileDate(e.draft, e.resolvedDateFormat, e.resolvedLocale) : "--"), 1)
                  ]),
                  _: 1
                }),
                l(p, { label: "Time" }, {
                  default: t(() => [
                    i(n(e.draft ? e.formatMobileTime(e.draft, e.resolvedTimeFormat, e.resolvedLocale) : "--"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            l(C, {
              modelValue: e.draft,
              "onUpdate:modelValue": o[7] || (o[7] = (r) => e.draft = r),
              "initial-value": e.initialValue,
              format: e.resolvedTimeFormat,
              locale: e.resolvedLocale,
              "hours-filter": e.hoursFilter,
              "minutes-filter": e.minutesFilter,
              "is-active": e.timePopover && e.timePopover.state === "open",
              "hour-step": e.hourStep,
              "minute-step": e.minuteStep
            }, null, 8, ["modelValue", "initial-value", "format", "locale", "hours-filter", "minutes-filter", "is-active", "hour-step", "minute-step"]),
            l(D, {
              disabled: e.invalid,
              onApply: o[8] || (o[8] = (r) => {
                e.apply(), e.timePopover && e.timePopover.close();
              }),
              onReset: o[9] || (o[9] = (r) => {
                e.reset(), e.timePopover && e.timePopover.close();
              })
            }, null, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["class", "custom-styles", "trigger"]),
        E
      ]),
      _: 1
    }, 8, ["variant", "size", "invalid", "readonly", "disabled"])), [
      [v, e.toggleDatePopover],
      [f, e.closeDatePopover]
    ]),
    e.$slots.hint || e.hint ? m((d(), s(q, {
      key: 1,
      disabled: e.disabled
    }, {
      default: t(() => [
        b(e.$slots, "hint", {}, () => [
          i(n(e.hint), 1)
        ])
      ]),
      _: 3
    }, 8, ["disabled"])), [
      [k, !e.error]
    ]) : T("", !0),
    m(l(M, { disabled: e.disabled }, {
      default: t(() => [
        i(n(e.error), 1)
      ]),
      _: 1
    }, 8, ["disabled"]), [
      [k, typeof e.error == "string" && e.error.length > 0]
    ])
  ], 2);
}
const W = /* @__PURE__ */ z(I, [["render", N]]);
export {
  W as O
};
//# sourceMappingURL=OrDateTimePicker-CGIojTPp.mjs.map
